/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { GeneralContext } from '../../core/app-context/GeneralContext';
import Footer from './Footer';
import Header from './Header';
import SideBar from './SideBar';

function Layout() {
  const { loading, menuOpen, setMenuOpen } = useContext(GeneralContext);

  return (
    <>
      <Header />
      <SideBar />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'var(--color-white-f5)',
          width: 'calc(100vw - 237px)',
          minHeight: 'calc(100vh - 115px)',
          marginLeft: '237px',
          marginTop: '66px',
          boxSizing: 'content-box',
        }}
        onClick={() => menuOpen && setMenuOpen(false)}
      >
        <Outlet style={{ marginLeft: '28px' }} />
      </div>
      <Footer />
    </>
  );
}

export default Layout;
